<template>
    <!-- 对话框 -->
    <el-dialog title="信息管理" :visible.sync="show" :before-close="closeDialog" width="90%" class="editcash">
        <!-- 基本信息表单 -->
        <div class="form-box">
            <template>
                <el-form ref="form" :model="submit_data" label-width="100px" style="overflow-y: auto; height: 50vh; margin-top: 20px">
                    <el-form-item label="选择端口:" disabled>
                        <!-- 下拉选择端口 -->
                        <el-select v-model="submit_data.port" placeholder="请选择端口" style="width: 200px" @change="portChange" disabled clearable>
                            <el-option label="司机端" value="driver"> </el-option>
                            <el-option label="乘客端" value="consumer"> </el-option>
                        </el-select>
                    </el-form-item>

                    <div v-if="submit_data.port != ''">
                        <div class="main-wrap clearfix">
                            <div>
                                <el-form-item label="分账接收方名称（需与营业执照的企业名称一致）:" >
                                    <el-input v-model="psReceiverName" style="width: 200px; margin-right: 5px" disabled> </el-input>
                                </el-form-item>
                                <el-form-item label="分账证明材料（业务合作合同）:" class="acitve" >
                                    <el-image v-for="item in img_url.psDocId" :preview-src-list="srcList" :src="item" class="avatar psDocId-img"></el-image>
                                </el-form-item>

                                    <div class="text-red">
                                        *注：盖章的分账证明材料（此份材料联系业务经理盖章办理）、入驻平台的合同，需加盖公章
                                    </div>

                                <el-form-item label="企业营业执照:" >
                                    <el-image :preview-src-list="srcList" :src="img_url.receiverCertFileId" class="avatar"> </el-image>
                                </el-form-item>
                                <el-form-item label="门头照:" >
                                    <el-image :preview-src-list="srcList" :src="img_url.storePicFileId" class="avatar"> </el-image>
                                </el-form-item>
                            </div>
                            <div class="aaa">
                                <div style="font-weight: 700; text-indent: 10%">法人信息</div>
                                <el-form-item label="姓名:" >
                                    <el-input v-model="manName" style="width: 200px; margin-right: 5px" disabled> </el-input>
                                </el-form-item>
                                <div style="font-weight: 700">证件类型：身份证</div>
                                <el-form-item label="证件号码:">
                                    <el-input v-model="certNo" maxlength="18" style="width: 200px; margin-right: 5px" disabled> </el-input>
                                </el-form-item>
                                <el-form-item label="证件生效日期:">
                                    <el-date-picker
                                        type="date"
                                        v-model="certEffectDate"
                                        value-format="yyyyMMdd"
                                        style="width: 200px"
                                        disabled
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="证件失效日期:">
                                    <el-date-picker
                                        type="date"
                                        v-model="certExpireDate"
                                        value-format="yyyyMMdd"
                                        style="width: 200px"
                                        disabled
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="联系手机:">
                                    <el-input v-model="ctctCell" maxlength="11" style="width: 200px; margin-right: 5px" disabled>
                                    </el-input>
                                </el-form-item>
                                <div style="font-weight: 700; text-indent: 10%">身份证照片</div>
                                <el-form-item label="身份证人像面:" >
                                    <el-image :preview-src-list="srcList" :src="img_url.faceImageFileId" class="avatar"> </el-image>
                                </el-form-item>

                                <span>身份证照片</span>
                                <el-form-item label="身份证国徽面:">
                                    <el-image :preview-src-list="srcList" :src="img_url.nationalImageFileId" class="avatar"> </el-image>
                                </el-form-item>
                            </div>
                            <div class="aaa">
                                <div style="font-weight: 700; text-indent: 9%">开户行信息</div>
                                <el-form-item label="省份:">
                                    <el-input v-model="submit_data.bankProvince" style="width: 200px; margin-right: 5px" disabled>
                                    </el-input>
                                </el-form-item>

                                <el-form-item label="城市:">
                                    <el-input v-model="submit_data.bankCity" style="width: 200px; margin-right: 5px" disabled> </el-input>
                                </el-form-item>
                                <el-form-item label="开户网点名称:">
                                    <el-input v-model="submit_data.bankName" style="width: 200px; margin-right: 5px" :disabled="type==0"> </el-input>
                                </el-form-item>
                                <el-form-item label="银行账户名称:">
                                    <el-input v-model="submit_data.bankAccountName" style="width: 200px; margin-right: 5px" :disabled="type==0"> </el-input>
                                </el-form-item>
                                <span>例：广州银联网络支付有限公司</span>

                                <el-form-item label="银行账号:">
                                    <el-input v-model="submit_data.bankAccountNo" style="width: 200px; margin-right: 5px" :disabled="type==0"> </el-input>
                                </el-form-item>

                                <el-form-item label="银行代码:">
                                    <el-select
                                        filterable
                                        v-model="value_bank_code"
                                        placeholder="请选择银行代码"
                                        @visible-change="bankCodeListsChange"
                                        @change="bankChange"
                                        clearable
                                        :disabled="type==0"
                                        style="width: 180px; margin-right: 20px"
                                    >
                                        <el-option
                                            v-for="item in options_bank_code"
                                            :key="item.value"
                                            :label="item.bank_name"
                                            :value="item.bank_code"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="统一社会信用代码:">
                                    <el-input v-model="receiverCertNo" style="width: 200px; margin-right: 5px" disabled> </el-input>
                                </el-form-item>
                                <el-form-item label="开户许可证照片:" v-if="type == 0">
                                    <el-image
                                        :preview-src-list="srcList"
                                        v-if="img_url.bankAccountFileId"
                                        :src="img_url.bankAccountFileId"
                                        class="avatar"
                                    ></el-image>

                                </el-form-item>

                                <el-form-item label="开户许可证照片:" v-else>
                                    <el-image
                                        :preview-src-list="srcList"
                                        v-if="img_url.bankAccountFileId"
                                        :src="img_url.bankAccountFileId"
                                        class="avatar"
                                    ></el-image>
                                    <el-upload
                                        :class="img_url.bankAccountFileId ? 'border-none' : ''"
                                        class="avatar-uploader"
                                        :action="img_upload_url"
                                        :show-file-list="false"
                                        :on-success="bankAccountFileIdSuccess"
                                        :before-upload="beforeAvatarUpload"
                                        :headers="img_headers"

                                    >
                                        <el-button
                                            slot="trigger"
                                            v-if="img_url.bankAccountFileId"
                                            @click="img_url.bankAccountFileId = ''"
                                            style="width: 100px; margin-top: 10px"
                                            >更换图片
                                        </el-button>
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="电子联行号:">
                                    <el-input v-model="submit_data.bankNetCode" maxlength="12" style="width: 200px; margin-right: 5px" :disabled="type==0">
                                    </el-input>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>
                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center; margin-top: 20px">
                    <el-button type="primary" @click="onSubmit">确定</el-button>

                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>

        <!--当前页面可以是从列表的获取短信验证码按钮进来的，
            也可能是从信息变更或重新提交按钮进来的，所以给验证码组件传值busType要从详情接口获取-->
        <messageDialog
            :isShow="msg_isShow"
            :applyNo="applyNo"
            :busType="busType"
            :port="submit_data.port"
            @messageSucss="onSubmitDig"
        ></messageDialog>
    </el-dialog>
</template>

<script>
var _this, t;
import { config } from '../../../utils/config'; // 配置
import axios from 'axios'; // AJAX封装类
import messageDialog from './messageDialog.vue';

export default {
    props: {
        isShow: Boolean,
        data: '',
        type: ''
    },
    components: {
        messageDialog
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this.submit_data.psNo = _this.data;

            // 获取银行代码列表信息
            _this.getbankCodeLists();
            _this.getCashierApplyDetails();

            // 获取上传图片的地址
            this.img_upload_url = config.axios_imgURL;

            // 清空图片的路径
            this.img_url = {
                //分账证明材料ID
                psDocId: [],
                //身份证人像面照片
                faceImageFileId: '',
                //身份证国徽面照片
                nationalImageFileId: '',
                //开户许可证照片
                bankAccountFileId: '',
                //门头照
                storePicFileId: '',
                //接收方证件文件ID（营业执照）
                receiverCertFileId: ''
            };

            let cityName = JSON.parse(localStorage.getItem('login')).city.name;
            console.log(cityName);

            // x为字符串第一个'/'的下标
            let x = cityName.indexOf('/');
            console.log(cityName.indexOf('/'));

            // 省
            _this.submit_data.bankProvince = cityName.slice(0, x - 1);

            let y = cityName.slice(x + 2).indexOf('/');

            if (y < 0) {
                // 当前城市为市级

                // 市
                _this.submit_data.bankCity = cityName.slice(x + 2);
            } else {
                // 当前城市为区县级

                // 市

                _this.submit_data.bankCity = cityName.slice(x + 2).slice(0, y - 1);
            }
        }
    },

    data() {
        return {
            show: false,

            msg_isShow: false,

            busType: '',
            applyNo: '',



            // 下拉搜索银行代码
            value_bank_code: '',
            options_bank_code: [],

            // selectPages_data: [],

            // 图片上传地址
            img_upload_url: '',

            srcList: [],

            //上传图片
            img_url: {
                //分账证明材料ID
                psDocId: '',
                //身份证人像面照片
                faceImageFileId: '',
                //身份证国徽面照片
                nationalImageFileId: '',
                //开户许可证照片
                bankAccountFileId: '',
                //门头照
                storePicFileId: '',
                //接收方证件文件ID（营业执照）
                receiverCertFileId: ''
            },

            //压缩质量
            imgQuality: 0.5,

            // 短信验证码
            message_data: '',

            // 短信验证码验证规则
            message_rules: {
                placeholder: '短信验证码',
                rules: {
                    required: true,
                    message: '短信验证码不能为空',
                    regulation: 'elt_str',
                    rulesData: 6
                }
            },

            //企业名称
            psReceiverName: '',
            //分账证明材料ID
            psDocId: [],
            //统一社会信用代码
            receiverCertNo: '',
            //接收方证件文件ID
            receiverCertFileId: '',
            //门头照
            storePicFileId: '',

            //法人姓名
            manName: '',
            //法人身份证号码
            certNo: '',
            //法人电话
            ctctCell: '',
            //证件生效日期 格式
            certEffectDate: '',
            //身份证人像面照片
            faceImageFileId: '',
            //证件失效日期 格式
            certExpireDate: '',
            //身份证国徽面照片
            nationalImageFileId: '',

            // 表单数据
            submit_data: {
                //端口类型
                port: '',

                //开户网点名称
                bankName: '',
                //银行账号
                bankAccountNo: '',
                //银行账户名称
                bankAccountName: '',
                //银行代码
                bankCode: '',
                //开户许可证照片
                bankAccountFileId: '',
                //电子联行号
                bankNetCode: '',

                //开户行省份
                bankProvince: '',
                //开户行城市
                bankCity: '',

                psNo: ''
            },

            submit_rules: {
                port: {
                    placeholder: '端口类型',
                    rules: {
                        required: true,
                        message: '端口错误',
                        regulation: 'gt_str',
                        rulesData: '0|1'
                    }
                },

                bankProvince: {
                    placeholder: '开户行省份',
                    rules: {
                        required: true,
                        message: '省份未选择',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                bankCity: {
                    placeholder: '开户行城市',
                    rules: {
                        required: true,
                        message: '城市未选择',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                bankName: {
                    placeholder: '开户网点名称需在50字之内',
                    rules: {
                        required: true,
                        message: '开户网点名称需在50字之内',
                        regulation: 'elt_str',
                        rulesData: 50
                    }
                },
                bankAccountNo: {
                    placeholder: '请输入银行卡号',
                    rules: {
                        required: true,
                        message: '银行卡号信息输入不正确',
                        regulation: 'elt_str',
                        rulesData: '20'
                    }
                },
                bankAccountName: {
                    placeholder: '银行账号名称需在50字之内',
                    rules: {
                        required: true,
                        message: '银行账号名称需在50字之内',
                        regulation: 'elt_str',
                        rulesData: 50
                    }
                },
                bankCode: {
                    placeholder: '银行代码',
                    rules: {
                        required: true,
                        message: '银行代码',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                bankAccountFileId: {
                    placeholder: '开户许可证照片',
                    rules: {
                        required: true,
                        message: '开户许可证照片哈希值错误',
                        regulation: 'special',
                        rulesData: 'json_array'
                    }
                },
                bankNetCode: {
                    placeholder: '电子联行号',
                    rules: {
                        required: true,
                        message: '电子联行号不能为空',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                }
            },
            // 上传图片的请求头
            img_headers: {
                token: '',
                'hash-key': '',
                platform: 'pc',
                'app-version': 'admin',
                port: 'admin',
                'city-tag': localStorage.getItem('city_tag'),
                'service-tag':localStorage.getItem('service_tag')
            }
        };
    },

    created() {
        _this = this;
    },
    methods: {
        getCashierApplyDetails() {
            _this
                .$post('/easy_cashier/getCashierApplyDetails', {
                    psNo: _this.submit_data.psNo
                })
                .then((res) => {
                    _this.applyNo = res.data.applyNo;
                    console.log(_this.applyNo);
                    _this.busType = res.data.busType;
_this.srcList = [...res.data.psDocId_url,res.data.receiverCertFileId_url,res.data.storePicFileId_url,
res.data.bankAccountFileId_url,res.data.faceImageFileId_url,res.data.nationalImageFileId_url];
                    _this.submit_data.port = res.data.port.val;
                    _this.psReceiverName = res.data.psReceiverName;
                    _this.psDocId = res.data.psDocId;
                    _this.img_url.psDocId = res.data.psDocId_url;
                    _this.receiverCertNo = res.data.receiverCertNo;
                    _this.receiverCertFileId = res.data.receiverCertFileId;
                    _this.img_url.receiverCertFileId = res.data.receiverCertFileId_url;
                    _this.storePicFileId = res.data.storePicFileId;
                    _this.img_url.storePicFileId = res.data.storePicFileId_url;
                    _this.submit_data.bankProvince = res.data.bankProvince;
                    _this.submit_data.bankCity = res.data.bankCity;
                    _this.submit_data.bankName = res.data.bankName;
                    _this.submit_data.bankAccountNo = res.data.bankAccountNo;
                    _this.submit_data.bankAccountName = res.data.bankAccountName;
                    _this.submit_data.bankCode = res.data.bankCode;
                    _this.submit_data.bankAccountFileId = res.data.bankAccountFileId;
                    _this.img_url.bankAccountFileId = res.data.bankAccountFileId_url;
                    _this.submit_data.bankNetCode = res.data.bankNetCode;
                    _this.manName = res.data.manName;
                    _this.certNo = res.data.certNo;
                    _this.ctctCell = res.data.ctctCell;
                    _this.certEffectDate = res.data.certEffectDate;
                    _this.faceImageFileId = res.data.faceImageFileId;
                    _this.img_url.faceImageFileId = res.data.faceImageFileId_url;
                    _this.certExpireDate = res.data.certExpireDate;
                    _this.nationalImageFileId = res.data.nationalImageFileId;
                    _this.img_url.nationalImageFileId = res.data.nationalImageFileId_url;

                    _this.value_bank_code = res.data.bankCode;
                })
                .catch((err) => {});
        },

        // 搜索银行代码
        getbankCodeLists() {
            _this
                .$post('/easy_cashier/bankCodeLists')
                .then((res) => {
                    _this.options_bank_code = res.data;
                })
                .catch((err) => {});
        },

        //搜索的下拉框弹出触发
        bankCodeListsChange(val) {
            _this.getbankCodeLists();
        },
        //选择下拉弹框值时触发
        bankChange(val) {
            console.log(val);

            _this.submit_data.bankCode = val;
        },

        onSubmit() {

            if (_this.type == '0') {

                // 请求短信重发接口

                _this
                    .$post('/easy_cashier/cashierPsSmsReNotify', {
                        applyNo: _this.applyNo,
                        busType: _this.busType,
                        port: _this.submit_data.port
                    })
                    .then((res) => {

                        _this.msg_isShow = !_this.msg_isShow;
                    })
                    .catch((err) => {});

            } else {
                // 请求编辑保存接口
                if (Number(_this.submit_data.certExpireDate) <= Number(_this.submit_data.certEffectDate)) {
                    _this.$message.error('证件失效日期应大于证件生效日期');
                    return;
                }

                // 分账接收方账户变更申请V2
                _this.$post('/easy_cashier/cashierAccountApply', _this.submit_data, _this.submit_rules).then((res) => {
                    _this.busType = '1';
                    _this.applyNo = res.data.response.data.applyNo;
                    _this.msg_isShow = !_this.msg_isShow;
                });
            }

            // console.log(_this.submit_data);
        },

        // 文件上传
        cashierUpload(img_hash, submit_img_id) {
            return new Promise((resolve, reject) => {
                _this
                    .$post('/easy_cashier/cashierUpload', {
                        img_hash: img_hash,
                        port: _this.submit_data.port
                    })
                    .then((res) => {
                        _this.submit_data[submit_img_id] = res.data.response.data.psFileId;
                        resolve();
                    })
                    .catch((err) => {});
            });
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;


            for (const key in _this.submit_data) {
                _this.submit_data[key] = '';
            }
        },
        // 提交按钮的请求方法
        onSubmitDig() {
            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();
        },

        // 开户许可证照片上传成功后执行
        async bankAccountFileIdSuccess(res, file) {
            if (res.code != 200) {
                _this.$message.error('图片上传失败');
                return;
            }

            // 将返回的哈希值存到submit_data对象
            _this.submit_data.bankAccountFileId = res.data.img_hash;
            await _this.cashierUpload(res.data.img_hash, 'bankAccountFileId');
            // 设置img标签显示的图片路径
            _this.img_url.bankAccountFileId = URL.createObjectURL(file.raw);

            _this.srcList[0] = this.img_url.bankAccountFileId;
        },

        // 图片压缩方法
        dataURItoBlob(dataURI, type) {
            var binary = atob(dataURI.split(',')[1]);
            var array = [];
            for (var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], {
                type: type
            });
        },

        // 图片上传之前执行的函数
        beforeAvatarUpload(file) {
            // 添加请求头
            _this.img_headers.token = localStorage.getItem(config.localStorage_token_name);
            _this.img_headers['hash-key'] = _this.$hash_key();

            return new Promise((resolve) => {
                const reader = new FileReader();
                const image = new Image();
                image.onload = (imageEvent) => {
                    const canvas = document.createElement('canvas');
                    const context = canvas.getContext('2d');
                    const width = image.width * _this.imgQuality;
                    const height = image.height * _this.imgQuality;
                    canvas.width = width;
                    canvas.height = height;
                    context.clearRect(0, 0, width, height);
                    context.drawImage(image, 0, 0, width, height);
                    const dataUrl = canvas.toDataURL(file.type);
                    const blobData = _this.dataURItoBlob(dataUrl, file.type);
                    resolve(blobData);
                };
                reader.onload = (e) => {
                    image.src = e.target.result;
                };
                reader.readAsDataURL(file);
            });
        },

        portChange() {
            _this.psDocId = '';
            _this.faceImageFileId = '';
            _this.nationalImageFileId = '';
            _this.submit_data.bankAccountFileId = '';
            _this.storePicFileId = '';
            _this.receiverCertFileId = '';

            _this.img_url = {
                //分账证明材料ID
                psDocId: '',
                //身份证人像面照片
                faceImageFileId: '',
                //身份证国徽面照片
                nationalImageFileId: '',
                //开户许可证照片
                bankAccountFileId: '',
                //门头照
                storePicFileId: '',
                //接收方证件文件ID（营业执照）
                receiverCertFileId: ''
            };

            _this.value_bank_code = '';
            _this.srcList = [];
        },

        // 判断图片的img_url是否存在
        imgUrlDeg() {
            if (
                _this.img_url.psDocId !== '' &&
                _this.img_url.receiverCertFileId !== '' &&
                _this.img_url.storePicFileId !== '' &&
                _this.img_url.bankAccountFileId !== '' &&
                _this.img_url.faceImageFileId !== '' &&
                _this.img_url.nationalImageFileId !== ''
            ) {
                return true;
            } else {
                _this.$message.error({
                    message: '未上传图片信息',
                    duration: 1500
                });
                return false;
            }
        }
    }
};
</script>
<style>
.editcash .el-dialog {
    margin-top: 8vh !important;
}
.acitve>.el-form-item__content{
    display: flex;
    width: 440px;
    flex-wrap: wrap;
}
.psDocId-img {
    margin: 5px;
}
</style>
<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
    height: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 100px;
    height: 100px;
    display: block;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}

.avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.verify_remarks {
    font-size: 14px;
    color: #606266;
}
.main-wrap{
    margin: 0 auto;
    width: 1750px;
    overflow-x: auto;
}
.main-wrap>div{

    width: 550px;
    float: left;

}
</style>